import ViewOrderDetails from "components/Modals/ViewOrderDetails";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardFooter,
  Row,
  Button,
  Input,
  Col,
  FormGroup,
  Spinner,
} from "reactstrap";
import { getCheckoutResponses } from "store/actions/checkoutQuestionAction";
import Pagination from "components/shared/Pagination";
import TableComponent from "components/shared/Table";
import ResponseDetailsModal from "components/Modals/ResponseDetails";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function CheckoutResponsesTable() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { responses, responseLoading } = useSelector(
    (state) => state.checkoutQuestion
  );

  const [filteredResponses, setFilteredResponses] = useState(responses);
  const [customerName, setCustomerName] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [responseDetails, setResponseDetails] = useState(false);
  const [singleOrder, setSingleOrder] = useState({});
  const [selectedResponse, setSelectedResponse] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const history = useHistory();

  useEffect(() => {
    dispatch(getCheckoutResponses(id));
  }, [dispatch, id]);

  useEffect(() => {
    setFilteredResponses(responses);
  }, [responses]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const numPages = Math.ceil(filteredResponses?.length / pageSize);

  const handleCustomerName = (event) => {
    setCustomerName(event.target.value);
  };

  const handlePageChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const viewDetailsToggle = () => setViewDetails(!viewDetails);

  const viewResponseToggle = () => setResponseDetails(!responseDetails);

  useEffect(() => {
    const filtered = responses.filter((response) =>
      response?.customerName?.toLowerCase().includes(customerName.toLowerCase())
    );
    setFilteredResponses(filtered);
  }, [customerName, responses]);

  return (
    <Row>
      <ViewOrderDetails
        viewDetails={viewDetails}
        viewDetailsToggle={viewDetailsToggle}
        singleOrder={singleOrder}
      />

      <ResponseDetailsModal
        toggle={viewResponseToggle}
        modal={responseDetails}
        selectedResponse={selectedResponse}
      />
      <div className="col">
        <Card className="shadow">
          <CardHeader className="d-lg-flex justify-content-between align-items-center">
            <div className="d-flex">
              <Button
                size="sm"
                color="primary"
                onClick={() => {
                  history.push("/admin/checkoutQuestions");
                }}
              >
                <i className="fas fa-arrow-left"></i>
              </Button>
              <h3 className="mb-0 ml-2">Checkout Responses</h3>
            </div>
            <Row>
              <Col xs="12" sm="6" lg="6">
                <Input
                  placeholder="Search by name..."
                  value={customerName}
                  onChange={handleCustomerName}
                />
              </Col>
              <Col xs="12" sm="6" lg="6" className="my-2 my-sm-0">
                <FormGroup className="mb-0 mx-2">
                  <Input
                    id="exampleSelect"
                    value={pageSize}
                    onChange={handlePageChange}
                    type="select"
                  >
                    <option value="5">Show Entries</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </CardHeader>

          {responseLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner size="md" color="primary" />
            </div>
          ) : (
            <TableComponent
              className="align-items-center table-flush"
              responsive
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col">Customer Name</th>
                  <th scope="col">Response</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredResponses?.length > 0 ? (
                  filteredResponses
                    .slice(startIndex, endIndex)
                    .map((el, idx) => (
                      <tr key={idx}>
                        <th scope="row">{el?.customerName}</th>
                        <td>
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "150px",
                            }}
                            title={el?.answer}
                          >
                            {el?.answer}
                          </div>
                        </td>

                        <td>
                          <Button
                            className="btn-sm"
                            color="success"
                            onClick={() => {
                              setSelectedResponse(el);
                              viewResponseToggle();
                            }}
                          >
                            View Response
                          </Button>
                          <Button
                            className="btn-sm"
                            color="primary"
                            onClick={() => {
                              viewDetailsToggle();
                              setSingleOrder(el);
                            }}
                          >
                            View Order Details
                          </Button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      No Response Added
                    </td>
                  </tr>
                )}
              </tbody>
            </TableComponent>
          )}
          <CardFooter className="py-4">
            <Pagination
              currentPage={currentPage - 1}
              totalPages={numPages}
              onPageChange={(page) => setCurrentPage(page + 1)}
            />
          </CardFooter>
        </Card>
      </div>
    </Row>
  );
}

export default CheckoutResponsesTable;
